import Vue from "vue";
import VueRouter from "vue-router";
import FilmPlatform from "../views/film/FilmPlatform.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: FilmPlatform,
    name: "FilmPlatform",
    meta: { title: "蝴蝶影视平台 · 让好故事被看见" },
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
